export const navigation = [
    {
      title: 'PROJECT',
      path: '/project/main-theme',
      description: `PROJECT 카테고리는 졸업전시회의 다양한 콘텐츠를
담고있는 공간입니다.

이 카테고리는 졸업전시회의 전반적인 주제와 관련된 콘텐츠를 통해 관람객이 전시회를 이해하고 즐길 수 있도록 돕습니다. 또한, 팀별 주제와 룩북, 쇼 런웨이, 디자이너의 작품을 통해 학생들의 다양한 아이디어와 작품들을 소개합니다.`,
      subItems: [
        { name: 'MAIN THEME', path: '/project/main-theme' },
        { name: 'LOOK BOOK', path: '/project/look-book' },
        { name: 'RUNWAY', path: '/project/runway' },
      ]
    },
    {
      title: 'TEAMS',
      path: '/teams',
      description: 'SOMA를 구성하는 여섯 팀의 주제와 디자이너들의 작품을 만나보세요.',
      subItems: [
        { name: 'ALL TEAMS', path: '/teams' },
        { name: 'AGIOTITA', path: '/team/agiotita' },
        { name: 'BIPOLAR', path: '/team/bipolar' },
        { name: '" - - - "', path: '/team/dash' },
        { name: 'Dialysis', path: '/team/dialysis' },
        { name: '표류[ ]기', path: '/team/drift' },
        { name: '자각몽', path: '/team/lucid-dream' },
      ]
    },
    {
      title: 'SHOW INFO',
      path: '/show-info/exhibition',
      description: `SHOW INFO 카테고리는 졸업전시회의 전반적인 정보를 제공하는 공간입니다.

이 카테고리는 관람객이 전시회를 쉽게 이해하고 즐길 수 있도록 전시정보와 관람정보를 제공하고, 오시는 길에 대한 정보도 함께 안내합니다.`,
      subItems: [
        { name: '전시 안내', path: '/show-info/exhibition' },
        { name: '팀 크레딧', path: '/show-info/staffRoll' },
        { name: '오시는 길', path: '/show-info/location' }
      ]
    },
    {
      title: 'BEHIND',
      path: '/behind/show',
      description: `BEHIND 카테고리는 졸업전시회의 비하인드 스토리를 담은 공간입니다.
     
이 카테고리는 전시회와 관련된 다양한 비하인드
콘텐츠를 통해 관람객이 전시의 제작 과정과 준비과정을 이해하고 감상할 수 있도록 돕습니다.`,
      subItems: [
        { name: 'SHOW BEHIND', path: '/behind/show' },
        { name: 'BROCHURE BEHIND', path: '/behind/brochure' },
        { name: 'MAKING BEHIND', path: '/behind/making' }
      ]
    },
    {
      title: 'ARCHIVE',
      path: '/archive',
      description: `ARCHIVE 카테고리는 이전 졸업전시회 웹사이트 링크를 모아둔 공간입니다.
     
이곳에서는 과거 전시회의 다양한 콘텐츠와 내용을
쉽게 찾아볼 수 있습니다. 졸업전시회의 역사를 되짚어보며, 졸업생들의 작품과 성과를 다시 한 번 감상할 수 있는 기회를 제공합니다.`,
      subItems: [
        { name: '2024:Prototype', path: '/2024' },
      ]
    }
  ];
